export default __webpack_public_path__ + "static/media/react-negative.e20e0ca4.svg";